import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from '@material-ui/core'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import { default as React, useMemo } from 'react'
import './InvoiceAmortisation.scss'
import { dateFormat } from 'helpers/StringNumberFunction/FormatDate'

export const InvoiceAmortisationItemContent = (props: any) => {
  const { listItem } = props

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
      backgroundColor: '#fff4dc',
    },
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }))

  const sortedListItem = useMemo(() => {
    return [...(listItem ?? [])].sort((a, b) => {
      const dateA = new Date(a?.AmortDate).getTime()
      const dateB = new Date(b?.AmortDate).getTime()

      if (!isNaN(dateA) && !isNaN(dateB) && dateA !== dateB)
        return dateA - dateB

      if ((a?.FYear ?? 0) !== (b?.FYear ?? 0))
        return (a?.FYear ?? 0) - (b?.FYear ?? 0)

      return (a?.FPeriod ?? 0) - (b?.FPeriod ?? 0)
    })
  }, [listItem])

  const totalAmount = listItem.reduce((sum, row) => sum + (row?.Amount || 0), 0)

  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            {listItem?.length <= 0 ? (
              <EmptyList
                title="No Record found"
                subtitle="Add a new record now."
              />
            ) : (
              <TableRow>
                <TableCell
                  className="StyledTableCell"
                  style={{ fontSize: '11px', color: 'white' }}
                  align="center"
                >
                  Fyear
                </TableCell>
                <TableCell
                  className="StyledTableCell"
                  style={{ fontSize: '11px', color: 'white' }}
                  align="center"
                >
                  Fperiod
                </TableCell>
                <TableCell
                  className="StyledTableCell"
                  style={{ fontSize: '11px', color: 'white' }}
                  align="center"
                >
                  Amort Date
                </TableCell>
                <TableCell
                  className="StyledTableCell"
                  style={{ fontSize: '11px', color: 'white' }}
                  align="center"
                >
                  Amount
                </TableCell>
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {sortedListItem.map((row, index) => {
              return (
                <>
                  <TableRow component={StyledTableRow}>
                    <TableCell style={{ fontSize: '11px' }} align="center">
                      {row?.FYear}
                    </TableCell>
                    <TableCell style={{ fontSize: '11px' }} align="center">
                      {row?.FPeriod}
                    </TableCell>
                    <TableCell style={{ fontSize: '11px' }} align="center">
                      {dateFormat(row?.AmortDate)}
                    </TableCell>
                    <TableCell style={{ fontSize: '11px' }} align="center">
                      {amtStr(row?.Amount)}
                    </TableCell>
                  </TableRow>
                </>
              )
            })}
            {listItem.length > 0 && (
              <TableRow component={StyledTableRow}>
                <TableCell
                  style={{ fontSize: '11px', fontWeight: 'bold' }}
                  align="center"
                >
                  Total
                </TableCell>
                <TableCell
                  style={{ fontSize: '11px' }}
                  align="center"
                ></TableCell>
                <TableCell
                  style={{ fontSize: '11px' }}
                  align="center"
                ></TableCell>
                <TableCell
                  style={{ fontSize: '11px', fontWeight: 'bold' }}
                  align="center"
                >
                  {amtStr(totalAmount)}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
